export default {
    pages1: [],
    pages2: [],
    pages3: [],
    pages4: [],
    pages5: [],
    pages6: [],
    pages7: [],
    pages8: [],
    pages9: [],
    pages10: [],
    pages11: [],
    pages12: [],
    media: [],

    index: false,
    loading: true,
    seeCover: true,

    audio: {
        id: 'elli',
        name: 'Elli Cover',
        file: new Audio('https://firebasestorage.googleapis.com/v0/b/mission-magazine-fb409.appspot.com/o/issue-5%2Fmedia%2FCover%20audio%20EllieGoldstein_SOLVE.mp3?alt=media&token=da8275cf-0f6b-4a07-9cee-847cf21046c6'),
        isPlaying: false
    },       
    audioI6: {
        id: 'issue6',
        name: 'issue6 Cover',
        file: new Audio('https://firebasestorage.googleapis.com/v0/b/mission-magazine-fb409.appspot.com/o/issue-6%2Fmedia%2Fissue-6.mp3?alt=media&token=bc17caab-6953-4479-bcb0-dc80082b5b09'),
        isPlaying: false
    },
    audioI7: {
        id: 'issue7',
        name: 'issue7 pg350',
        file: new Audio('https://firebasestorage.googleapis.com/v0/b/mission-magazine-fb409.appspot.com/o/issue-7%2Fmedia%2Fpg350_audioNike.mp3?alt=media&token=c573e427-ef8e-46e6-86d6-4921c5723ef6'),
        isPlaying: false
    },
    audioI12: {
        id: 'issue12',
        name: 'issue12 pg184',
        file: new Audio('https://firebasestorage.googleapis.com/v0/b/mission-magazine-fb409.appspot.com/o/issue-12%2Fmedia%2Fpg184_Jean_Dawson_Feels_It_All.mp3?alt=media&token=f5582c44-d22c-4a3d-a223-7b1fb5c82b4a'),
        isPlaying: false
    }
}